
import { SiriusBaseComponent } from 'sirius-framework';
import { Router } from '@angular/router'
import { Component } from '@angular/core';

@Component({
    selector: 'inner-menu-content',
    templateUrl: './inner-menu-content.component.html',
    styleUrls: ['./inner-menu-content.component.css']
})
export class InnerMenuContentComponent extends SiriusBaseComponent<any> {
    titleText: string;
    constructor(private router: Router) {
        super();      
    }
    OnInit() {
        this.titleText = 'İşlemler';
    }
}
